import {onFind} from "@elements/init-modules-in-scope";
import {trigger, removeAttribute, setAttribute, findIn} from "@elements/dom-utils";
import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as lightbox from '@elements/lightbox';
lightbox.init({
        // plugins: ['zoom', 'video'],
        // zoom: true,
        // video: true,
        mobileSettings: {
            controls: true
        }
    }
);

import * as productGridQuickFilter from './libs/@elements/quickFilter';
productGridQuickFilter.init();

import * as rangeSlider from '@elements/range-slider';
// rangeSlider.init();
onFind('.js-range-slider', function (slider) {
    rangeSlider.createRangeSlider(slider, {
        onSet: (sliderObj) => {
            console.log("range slider object", sliderObj);
            let range = JSON.parse(slider.getAttribute('data-range-slider-range'));
            if (sliderObj.values[0] > range.min) {
                removeAttribute('disabled', findIn('.js-range-slider__min', slider))
            } else {
                setAttribute('disabled', true, findIn('.js-range-slider__min', slider))
            }

            if (sliderObj.values[1] < range.max) {
                removeAttribute('disabled', findIn('.js-range-slider__max', slider))
            } else {
                setAttribute('disabled', true, findIn('.js-range-slider__max', slider))
            }

            trigger('range-slider.set', slider);
        }
    }, {
        slider: '.js-range-slider__slider',
        inputMin: '.js-range-slider__min',
        inputMax: '.js-range-slider__max'
    });
});

import * as dateInput from "@elements/date-input";
dateInput.init();

import * as datepicker from "@elements/datepicker";
datepicker.init();

import * as toggleForm from "./scripts/toggle-form";
toggleForm.init();

import * as productNav from './scripts/product-nav';
productNav.init();

import * as productGrid from './libs/@elements/productGrid';
productGrid.init();